import React from "react";

import { Button, Col, Modal, Row } from "react-bootstrap";

import { TreeNode, useGetArtistTreeQuery } from "@api/graphql";
import { Loading } from "@components/loading";

import ArtistTree, { TreeNodeWithChildren } from "./ArtistTree";

interface ViewBeneficiaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  rootArtistId: number;
}

const buildTree = (nodes: TreeNode[]): TreeNodeWithChildren[] => {
  const nodeMap: { [key: number]: TreeNodeWithChildren } = {};
  const tree: TreeNodeWithChildren[] = [];

  nodes.forEach((node) => {
    nodeMap[node.node_id] = { ...node, children: [] };
  });

  // Build the tree by associating children with their parents
  nodes.forEach((node) => {
    if (node.depth === 0) {
      tree.push(nodeMap[node.node_id]);
    } else {
      const parent = nodeMap[node.attributes.percentages[0].parent];
      if (parent) {
        parent.children?.push(nodeMap[node.node_id]);
      }
    }
  });

  return tree;
};

export const ViewBeneficiaryModal = ({ isOpen, onClose, rootArtistId }: ViewBeneficiaryModalProps) => {
  const { data, loading } = useGetArtistTreeQuery({
    variables: { artistId: rootArtistId ? rootArtistId : 0 },
    skip: !rootArtistId,
  });
  const nodes = data?.getArtistTree?.Nodes || [];
  const tree = buildTree(nodes);
  return (
    <Modal show={isOpen} size="lg" onHide={onClose}>
      <Modal.Header closeButton />
      <Modal.Body className="p-5">
        {loading && <Loading />}
        <Row className="mb-4 h5">Artist beneficiaries</Row>
        {tree.map((node) => (
          <ArtistTree key={node.node_id} node={node} />
        ))}
        <Row className="mt-4 mb-4 text-center">
          <Col>
            <Button type="submit" onClick={onClose}>
              Close
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ViewBeneficiaryModal;
